import React from 'react';

const Pagination = ({
    totalRecords = 0,
    pageSize = 50,
    pageNumber,
    totalPages = 1,
    setPageNumber,
    currentPage,
    onPageChange,
}) => {
    const activePage = Number(currentPage ?? pageNumber ?? 1);
    const safePageSize = Number(pageSize) || 50;
    const safeTotalRecords = Number(totalRecords) || 0;
    const safeTotalPages = Math.max(Number(totalPages) || 1, 1);
    const handlePageChange = onPageChange ?? setPageNumber ?? (() => {});

    const start = safeTotalRecords === 0 ? 0 : (activePage - 1) * safePageSize + 1;
    const end = safeTotalRecords === 0 ? 0 : Math.min(activePage * safePageSize, safeTotalRecords);

    return (
        <div className="d-md-flex align-items-center">
            <div className="me-md-auto text-md-left text-center mb-2 mb-md-0">
                Showing {start} to {end} of {safeTotalRecords} entries
            </div>
            <ul className="pagination mb-0 justify-content-center">
                <li className={`page-item ${activePage === 1 ? "disabled" : ""}`}>
                    <button
                        type="button"
                        className="page-link"
                        onClick={() => handlePageChange(activePage - 1)}
                        disabled={activePage === 1}
                    >
                        Previous
                    </button>
                </li>
                {[...Array(safeTotalPages)].map((_, index) => (
                    <li key={index} className={`page-item ${index + 1 === activePage ? "active" : ""}`}>
                        <button type="button" className="page-link" onClick={() => handlePageChange(index + 1)}>
                            {index + 1}
                        </button>
                    </li>
                ))}
                <li className={`page-item ${activePage === safeTotalPages ? "disabled" : ""}`}>
                    <button
                        type="button"
                        className="page-link"
                        onClick={() => handlePageChange(activePage + 1)}
                        disabled={activePage === safeTotalPages}
                    >
                        Next
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default Pagination;